export default __webpack_public_path__ + "static/media/DoubleArrowLeftIcon.02f6dbe7.svg";